module.exports = __webpack_public_path__ + "static/media/step01.a5445017.png";